"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var selectors_1 = require("../selectors");
var TagList_1 = __importDefault(require("./TagList"));
var track_event_1 = __importDefault(require("../../../utils/track-event"));
var Tag_1 = require("./Tag");
var OwnDesignBtn_1 = __importDefault(require("./OwnDesignBtn"));
var Categories_1 = __importDefault(require("./Filters/Categories"));
var SortBy_1 = __importDefault(require("./Filters/SortBy"));
var atoms_1 = require("../../styles/atoms");
var react_redux_1 = require("react-redux");
var selectors_2 = require("../../common/selectors");
var styled_components_1 = __importDefault(require("styled-components"));
var Sidebar = function () {
    var _a;
    var isCustomStore = (0, react_redux_1.useSelector)(selectors_2.isCustomStoreSelector);
    var tagsSidebar = (0, selectors_1.useTagsSidebarSelector)();
    var track = function (tagName) { return function () {
        (0, track_event_1.default)({
            category: 'store button',
            action: 'left sidebar click',
            label: tagName,
        });
    }; };
    return (react_1.default.createElement(atoms_1.Div, { className: "sidebar", visible: !!tagsSidebar },
        react_1.default.createElement(OwnDesignBtn_1.default, null),
        react_1.default.createElement(atoms_1.Div, { visible: isCustomStore, className: (0, classnames_1.default)('filters', 'for-hint', 'clearfix', (_a = {},
                _a['filters_custom-store'] = isCustomStore,
                _a)), "data-testid": "customStoreSidebar" },
            react_1.default.createElement(Categories_1.default, null),
            react_1.default.createElement(SortBy_1.default, null)),
        react_1.default.createElement(atoms_1.Div, { className: "sidebar__content", visible: !isCustomStore },
            react_1.default.createElement("div", { className: "tag-list" },
                react_1.default.createElement(TagListFeatured, null,
                    react_1.default.createElement(TagList_1.default, { tags: tagsSidebar.featured, tagClick: track })),
                react_1.default.createElement(TagListNormal, null,
                    react_1.default.createElement(TagList_1.default, { tags: tagsSidebar.normal, withChildren: true, tagClick: track }),
                    react_1.default.createElement(TagList_1.default, { tags: tagsSidebar.hidden, withChildren: true, tagClick: track }))))));
};
var TagListFeatured = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 16px;\n  background: ", ";\n  padding: 16px;\n  padding-top: 8px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n\n  @media (hover: none) {\n    margin-top: 0px;\n  }\n\n  ", " {\n    display: block;\n    width: 100%;\n    margin-top: 8px;\n  }\n"], ["\n  margin-top: 16px;\n  background: ", ";\n  padding: 16px;\n  padding-top: 8px;\n  border-radius: 6px;\n  margin-bottom: 16px;\n\n  @media (hover: none) {\n    margin-top: 0px;\n  }\n\n  ", " {\n    display: block;\n    width: 100%;\n    margin-top: 8px;\n  }\n"])), function (p) { return p.theme.colors.bg.secondary; }, Tag_1.TagLinkWrapper);
var TagListNormal = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  //\n\n  ", " {\n    margin-top: 24px;\n  }\n"], ["\n  //\n\n  ", " {\n    margin-top: 24px;\n  }\n"])), Tag_1.TagLinkWrapper);
exports.default = Sidebar;
var templateObject_1, templateObject_2;
